"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GridRow = /** @class */ (function (_super) {
    __extends(GridRow, _super);
    function GridRow(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    GridRow.prototype.bindAll = function () {
        this.onClick = this.onClick.bind(this);
    };
    GridRow.prototype.render = function () {
        var classes = this.rowClasses(this.props.options);
        var customOptions = (this.props.options && this.props.options.customOptions) ?
            this.props.options.customOptions : {};
        return (React.createElement("div", __assign({ "data-test-id": this.props.testId, className: classes.join(' ') }, customOptions, { onClick: this.props.events && this.props.events.onClick ? this.onClick : null }), this.props.children));
    };
    GridRow.prototype.rowClasses = function (options) {
        var classnames = [];
        if (options && options.noWrap) {
            classnames.push('row-nowrap');
        }
        else if (options && options.forceWrap) {
            classnames.push('row', 'flex-wrap');
        }
        else {
            classnames.push('row');
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        if (options && options.alignItems) {
            classnames.push([("flex-items-" + (options.alignItems
                    .charAt(0).toUpperCase() + options.alignItems.slice(1))).toLowerCase()]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.alignSelf) {
            classnames.push([("flex-self-" + (options.alignSelf
                    .charAt(0).toUpperCase() + options.alignSelf.slice(1))).toLowerCase()]);
        }
        if (options && options.noPad) {
            classnames.push('nopad');
        }
        return classnames;
    };
    GridRow.prototype.onClick = function () {
        if (this.props.events && this.props.events.onClick) {
            return this.props.events.onClick();
        }
    };
    return GridRow;
}(React.Component));
exports.default = GridRow;
//# sourceMappingURL=GridRow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridRow/GridRow.js
// module id = 1362
// module chunks = 8